import axios from 'axios'
import pageKeys from '../common/pagekeys'

export default {
    async getSettings() {
        try{            
            const response = await axios.get(`EmploymentTransition/settings`, {
                headers: {
                    'page_key': pageKeys.automated_reminders
                }
            })                             
            return response
        }catch (error){
            console.log('EmploymentTransition api getSettings error')
            throw error
        }
    },
    async updateSettings(data) {
        try{            
            const response = await axios.post(`EmploymentTransition/settings`, data,
            {
                headers: {
                    'page_key': pageKeys.automated_reminders
                }
            })             
            return response
        }catch (error){
            console.log('EmploymentTransition api updateSettings error')
            throw error
        }
    },
}